<template>
  <div>
  		<section class="banner_section">
			<div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
				<!-- Indicators -->
				<ol class="carousel-indicators">
					<li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
					<li data-target="#carousel-example-generic" data-slide-to="1"></li>
					<li data-target="#carousel-example-generic" data-slide-to="2"></li>
				</ol>
				<!-- Wrapper for slides -->
				<div class="carousel-inner" role="listbox">
					<div class="item active">
						<img src='/static/images/index/banner3.jpg' alt="i80愛幫您">
						<div class="carousel-caption">
						</div>
					</div>
					<div class="item" v-for="(row, index) in homeSlide">
						<img :src="row.image" alt="">
						<div class="carousel-caption">
							{{row.id}}
						</div>
					</div>
				</div>
				<!-- Controls -->
				<a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
					<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
					<span class="sr-only">Previous</span>
				</a>
				<a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
					<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
					<span class="sr-only">Next</span>
				</a>
			</div>
		</section>

		<section class="feature_section">
			<div class="container">
				<div class="row">
					<div class="col-md-3 col-sm-6 col-xs-12">
						<div class="feature_box">
							<div class="content">
								<h4>即時成效</h4>
								<p class="txt">平台即時呈現銷售資訊與追踪工具讓您瞭解通路表現，是精準且穩定的網路平台。</p>
								<a href="/operators" class="more">了解更多<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></a>
							</div>
							<span class="glyphicon glyphicon-time icon" aria-hidden="true"></span>
						</div>
					</div>
					<div class="col-md-3 col-sm-6 col-xs-12">
						<div class="feature_box">
							<div class="content">
								<h4>最高獎金</h4>
								<p class="txt">平台每件商品個人都享有10%的返利，推薦越多享受更多。</p>
								<a href="/operators" class="more">了解更多<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></a>
							</div>
							<span class="glyphicon glyphicon-usd icon" aria-hidden="true"></span>
						</div>
					</div>
					<div class="col-md-3 col-sm-6 col-xs-12">
						<div class="feature_box">
							<div class="content">
								<h4>優質商品</h4>
								<p class="txt">平台負責把關所有上架商品，讓消費者放心購買。</p>
								<a href="/operators" class="more">了解更多<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></a>
							</div>
							<span class="glyphicon glyphicon-thumbs-up icon" aria-hidden="true"></span>
						</div>
					</div>
					<div class="col-md-3 col-sm-6 col-xs-12">
						<div class="feature_box">
							<div class="content">
								<h4>服務專員</h4>
								<p class="txt">提供線上與實體客服，讓您快速了解平台與商品特色。</p>
								<a href="/contact" class="more">了解更多<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></a>
							</div>
							<span class="glyphicon glyphicon-user icon" aria-hidden="true"></span>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="step_section">
			<div class="container">
				<div class="row">
					<div class="col-md-3 col-xs-12">
						<h4 class="title main_title">i80：賺取回饋金三步驟</h4>
						<p>加入平台並使用推廣連結分享商品，當網友由連結導入至推廣的商品完成購買，您就即可獲取回饋金。</p>
						<p>簡單三步驟，您也能成為網路推廣者，趕緊加入愛幫您的行列吧!</p>
						<a class="btn btn-default i80_btn" href="/register">免費加入會員</a>
					</div>
					<div class="col-md-9 col-xs-12">
						<div class="jcarousel-wrapper">
							<div class="jcarousel">
								<ul>
									<li class="step_box">
										<a href="">
											<figure class="pic justify"><img :src="'/static/images/index/3-1.png'"></figure>
											<div class="content">
												<h5>我該如何選擇產品？</h5>
												<p>加入愛幫您：找你喜歡、有興趣、或專長領域的商品</p>
											</div>
										</a>
									</li>
									<li class="step_box">
										<a href="">
											<figure class="pic justify"><img :src="'/static/images/index/3-2.jpg'"></figure>
											<div class="content">
												<h5>我可以在哪裡推廣？</h5>
												<p>可以透過個人社群軟體、部落格親友、拜訪等做宣傳</p>
											</div>
										</a>
									</li>
									<li class="step_box">
										<a href="">
											<figure class="pic justify"><img :src="'/static/images/index/3-3.jpg'"></figure>
											<div class="content">
												<h5>我怎麼獲得獎金？</h5>
												<p>透過分享後，只要有產生消費，系統就會立即計算獎金給您</p>
											</div>
										</a>
									</li>
									<li class="step_box">
										<a href="">
											<figure class="pic justify"><img :src="'/static/images/index/3-4.jpg'"></figure>
											<div class="content">
												<h5>我該如何選擇產品？</h5>
												<p>加入聯盟網：找你喜歡、有興趣、或專長的商品</p>
											</div>
										</a>
									</li>
								</ul>
							</div>
							<a href="#" class="jcarousel-control-prev">&lsaquo;</a>
							<a href="#" class="jcarousel-control-next">&rsaquo;</a>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="news_section">
			<div class="container">
				<h4 class="title main_title session_title">最新消息</h4>
				<div class="row">
					<div class="col-md-6" v-for="(row, index) in news">
						<div class="news_box">
							<div class="date">
								<span class="day">{{row.c_date | formatDate}}</span>
								<span class="month">{{row.c_date | formatMonth}}月</span>
							</div>
							<h5 class="title">{{row.c_title}}</h5>
							<p class="txt">
								{{row.c_content | truncate(50) }}
								<router-link v-bind:to="'/news/'+index" class="pull-right more">
								了解更多<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
								</router-link>
							</p>
						</div>
					</div>

				</div>
			</div>
		</section>

		<!--
		<section class="adv_section">
			<div class="container">
				<figure><img src="https://fakeimg.pl/1170x100/" class="img-responsive"></figure>
			</div>
		</section>
		-->
		<section class="store_section">
			<div class="container">
				<h4 class="title main_title session_title">合作廠商</h4>
				<div class="row">
					<div class="col-md-2 col-xs-6" v-for="(row, index) in companies">
						<div class='store_box'>
							<router-link v-bind:to="'/store/'+row.comid">
								<figure class='pic justify'>
									<img v-if="row.com_image" v-bind:src="'https://files.i80.com.tw/images/product/'+row.com_image" class="img-responsive"/>
								</figure>
								<h5 class='title'>{{row.com_name}}</h5>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'

const homeSlide = [
  {
    id: 1,
    image: '/static/images/index/banner2.jpg'
  },
  {
    id: 2,
    image: '/static/images/index/banner3.jpg'
  }
]

export default {
  name: 'Main',
  data () {
    return {
      apiurl: this.$store.getters.getAPI,
      homeSlide: homeSlide
    }
  },
  mounted: function () {
    let companies = window.localStorage.getItem('companies')
    let news = window.localStorage.getItem('news')
    this.companies = JSON.parse(companies)
    this.news = JSON.parse(news)

    let shareid = this.$route.params.shareid
    if (shareid) {
      this.$store.dispatch('SET_SHARE_ID', shareid)
    }
  },
  methods: {
    ...mapActions([
      'SET_NEWS'
    ])
  },
  computed: {
    ...mapGetters({
      news: 'getNews',
      companies: 'getCompanies'
    })
  },
  filters: {
    formatDate: function (date) {
      return moment(date).format('DD')
    },
    formatMonth: function (date) {
      return moment(date).format('MM')
    },
    truncate: function (string, value) {
      let str = string.replace(/<\/?[^>]+(>|$)/g, '')
      return str.substring(0, value) + '...'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Main.vue?0355dab8